<template>
    <div class="search-header" :class="`search-pos-${settings.searchBoxPlacement}`">
        <label class="search-header__label" for="vue-search"
            :class="$root.searchInputTitle ? '' : 'sr-only'"
        >
            {{ $root.searchInputTitle || "Search CHFA" }}
        </label>
        <div class="search-header__form">
            <div class="search-header__input-wrapper">
                <input class="search-header__input" id="vue-search" type="text" :placeholder="settings.searchPlaceholder" @keypress.enter="submitSearch" v-model="query">
                <button type="button" class="search-header__clear" @click="clearSearch" aria-label="Clear search">&times;</button>
            </div>
            <button class="btn" type="submit" @click="submitSearch">{{settings.searchButtonText}}</button>
        </div>
        <SearchResultsText v-if="settings.searchBoxPlacement !== 'top'"/>
    </div>
</template>

<script>
    import SearchResultsText from "./SearchResultsText.vue";

    export default {
        components: {
            SearchResultsText
        },
        props: {
            searchPlaceholder: {
                type: String,
                default: "Enter search terms"
            },
            searchButtonText: {
                type: String,
                default: "Submit your search"
            }
        },
        methods: {
            submitSearch: function () {
                this.$emit('submitSearch', this.query);
            },
            clearSearch: function () {
                this.query = "";
                this.$emit('submitSearch', this.query);
            }
        },
        watch: {
            currentQuery() {
                this.query = this.$store.state.searchQuery.searchTerm;
            }
        },
        mounted: function () {
            this.query = this.currentQuery.searchTerm;
        },
        data: function () {
            return {
                query: ""
            }
        },
        computed: {
            settings: function () {
                return this.$store.state.settings;
            },

            currentResultStart: function () {
                if (this.results.currentPage == 0) {
                    return 1;
                } else {
                    return (this.results.currentPage * this.results.pageSize) + 1;
                }

            },
            currentResultsEnd: function () {
                if (this.results.currentPage == 0) {
                    if (this.results.totalResultCount <= this.results.pageSize) {
                        return this.results.totalResultCount;
                    } else {
                        return this.results.pageSize;
                    }
                } else {
                    var max = ((this.results.currentPage + 1) * this.results.pageSize) + 1;
                    if (max > this.results.totalResultCount) {
                        return this.results.totalResultCount;
                    } else {
                        return max;
                    }
                }
            },
            results: function () {
                return this.$store.state.results;
            },
            currentQuery: function () {
                return this.$store.state.searchQuery;
            }
        }
    }
</script>

<style>

</style>